// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Table = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 1H2a1 1 0 0 0-.993.883L1 2v12a1 1 0 0 0 .883.993L2 15h12a1 1 0 0 0 .993-.883L15 14V2a1 1 0 0 0-.883-.993z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M0 3h16v1H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5 1h1v14H5zM10 1h1v14h-1z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M0 7h16v1H0zM0 11h16v1H0z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Table);
export default ForwardRef;
